import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";

import {
GoogleMap,
Marker,
Circle,
useLoadScript
} from "@react-google-maps/api";

/* ================= STORE ================= */

const STORE_LOCATION = {
lat: 25.61252,
lng: 87.70147
};

const libraries = ["places"];

const containerStyle = {
width: "100%",
height: "260px",
borderRadius: "22px"
};

/* ================= DISTANCE ================= */

const getDistance = (lat1, lon1, lat2, lon2) => {
if (!lat1 || !lon1 || !lat2 || !lon2) return 0;

const toRad = (v) => (v * Math.PI) / 180;

const R = 6371;

const dLat = toRad(lat2 - lat1);

const dLon = toRad(lon2 - lon1);

const a =
Math.sin(dLat / 2) ** 2 +
Math.cos(toRad(lat1)) *
Math.cos(toRad(lat2)) *
Math.sin(dLon / 2) ** 2;

return (
R *
(2 *
Math.atan2(
Math.sqrt(a),
Math.sqrt(1 - a)
))
);
};

const ShopCheckOut = () => {
const navigate = useNavigate();

const userId = localStorage.getItem("userId");

const { isLoaded } = useLoadScript({
googleMapsApiKey:
process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
libraries
});

/* ================= STATES ================= */

const [cartItems, setCartItems] = useState([]);

const [savedAddresses, setSavedAddresses] =
useState([]);

const [selectedIndex, setSelectedIndex] =
useState(null);

const [showAddressList, setShowAddressList] =
useState(false);

const [loading, setLoading] =
useState(true);

const [placing, setPlacing] =
useState(false);

const [distance, setDistance] =
useState(0);

const [shippingCharge, setShippingCharge] =
useState(0);

const [smallOrderFee, setSmallOrderFee] =
useState(0);

const [eta, setEta] =
useState(0);

const [paymentMethod, setPaymentMethod] =
useState("ONLINE");

/* ================= COUPON ================= */

const [couponCode, setCouponCode] =
useState("");

const [discount, setDiscount] =
useState(0);

const [couponMessage, setCouponMessage] =
useState("");

const [appliedCoupon, setAppliedCoupon] =
useState(null);

/* ================= FORM ================= */

const [form, setForm] = useState({
name: "",
phone: "",
address: "",
city: "",
pincode: "",
lat: null,
lng: null
});

/* ================= INIT ================= */

useEffect(() => {
loadCart();
loadAddresses();
}, []);

/* ================= LOAD CART ================= */

const loadCart = async () => {
try {

const res = await api.get(
  `/api/cart/${userId}`
);

setCartItems(  
    res.data?.items || []  
  );  
} catch (err) {  
  console.log(err);  
}  

setLoading(false);

};

/* ================= LOAD ADDRESS ================= */

const loadAddresses = () => {
const data =
JSON.parse(
localStorage.getItem("addresses")
) || [];

setSavedAddresses(data);  

if (data.length === 0) return;  

let selected =  
  data.find((a) => a.isDefault);  

if (!selected) selected = data[0];  

const index = data.findIndex(  
  (a) =>  
    a.address === selected.address  
);  

const updated = {  
  ...selected,  
  lat: Number(selected.lat),  
  lng: Number(selected.lng),  
  city:  
    selected.city || "Sonaili",  
  pincode:  
    selected.pincode || "855114"  
};  

setForm(updated);  

setSelectedIndex(index);  

calculateDelivery(  
  updated.lat,  
  updated.lng  
);  

localStorage.setItem(  
  "selectedAddress",  
  JSON.stringify(updated)  
);

};

/* ================= SELECT ADDRESS ================= */

const selectAddress = (
addr,
index
) => {
setSelectedIndex(index);

const updated = {  
  ...addr,  
  lat: Number(addr.lat),  
  lng: Number(addr.lng),  
  city: addr.city || "Sonaili",  
  pincode:  
    addr.pincode || "855114"  
};  

setForm(updated);  

calculateDelivery(  
  updated.lat,  
  updated.lng  
);  

localStorage.setItem(  
  "selectedAddress",  
  JSON.stringify(updated)  
);  

setShowAddressList(false);

};

/* ================= DELIVERY ================= */

const calculateDelivery = (lat, lng) => {
  if (!lat || !lng) return;

  const dist = getDistance(
    STORE_LOCATION.lat,
    STORE_LOCATION.lng,
    lat,
    lng
  );

  setDistance(dist);

  // 10 KM ke bahar delivery nahi
  if (dist > 10) {
    setShippingCharge(0);
    setEta(0);
    return;
  }

  let charge = 0;

  /* =========================================
     ₹199 FREE DELIVERY RULE
     ONLY UPTO 3 KM
     ========================================= */

  if (
    dist <= 3 &&
    subtotal >= 99
  ) {
    charge = 0;
  }

  /* =========================================
     NORMAL DELIVERY CHARGE
     ========================================= */

  else if (dist <= 2) {
    charge = 0;
  }

  else if (dist <= 3) {
    charge = 0;
  }

  else if (dist <= 4) {
    charge = 10;
  }

  else if (dist <= 5) {
    charge = 20;
  }

  else if (dist <= 6) {
    charge = 30;
  }

  else if (dist <= 7) {
    charge = 40;
  }

  else if (dist <= 8) {
    charge = 50;
  }

  else if (dist <= 9) {
    charge = 60;
  }

  else if (dist <= 10) {
    charge = 80;
  }

  setShippingCharge(charge);

  const estimatedTime = Math.max(
    10,
    Math.round((dist / 25) * 60) + 8
  );

  setEta(estimatedTime);
};



/* ================= VALID ITEMS ================= */

const validCartItems =
cartItems.filter(
(i) =>
i?.productId &&
(i.productId?.price ||
i.price)
);

/* ================= SUBTOTAL ================= */

const subtotal =
validCartItems.reduce(
(sum, i) => {
const price = Number(
i.productId?.price ||
i.price ||
0
);

const qty = Number(  
      i.quantity || 0  
    );  

    return sum + price * qty;  
  },  
  0  
);

/* ================= SMALL ORDER ================= */

useEffect(() => {
setSmallOrderFee(
subtotal < 99 ? 20 : 0
);
}, [subtotal]);

/* ================= COUPON ================= */

const applyCoupon = () => {
const code =
couponCode
.trim()
.toUpperCase();

if (!code) {  
  setCouponMessage(  
    "Please enter coupon code"  
  );  
  return;  
}  

let discountAmount = 0;  

if (code === "SAVE10") {  
  discountAmount =  
    subtotal * 0.04;  

  if (discountAmount > 100) {  
    discountAmount = 100;  
  }  

  setCouponMessage(  
    `✅ SAVE10 Applied • Saved ₹${Math.round(  
      discountAmount  
    )}`  
  );  
} else if (  
  code === "FRESH50" &&  
  subtotal >= 999  
) {  
  discountAmount = 50;  

  setCouponMessage(  
    "✅ FRESH50 Applied • Flat ₹50 OFF"  
  );  
} else if (  
  code === "WELCOME200" &&  
  subtotal >= 5999  
) {  
  discountAmount = 200;  

  setCouponMessage(  
    "✅ WELCOME200 Applied • Saved ₹200"  
  );  
} else {  
  setDiscount(0);  

  setAppliedCoupon(null);  

  setCouponMessage(  
    "❌ Invalid coupon or minimum order not reached"  
  );  

  return;  
}  

setDiscount(  
  Math.round(discountAmount)  
);  

setAppliedCoupon(code);

};

/* ================= AUTO APPLY ================= */

const autoApplyCoupon = (code) => {
setCouponCode(code);

setTimeout(() => {  
  const upperCode =  
    code.toUpperCase();  

  let discountAmount = 0;  

  if (upperCode === "SAVE10") {  
    discountAmount =  
      subtotal * 0.03;  

    if (discountAmount > 100) {  
      discountAmount = 100;  
    }  

    setCouponMessage(  
      `✅ SAVE10 Applied • Saved ₹${Math.round(  
        discountAmount  
      )}`  
    );  
  } else if (  
    upperCode === "FRESH50" &&  
    subtotal >= 999  
  ) {  
    discountAmount = 50;  

    setCouponMessage(  
      "✅ FRESH50 Applied • Flat ₹50 OFF"  
    );  
  } else if (  
    upperCode ===  
      "WELCOME200" &&  
    subtotal >= 5999  
  ) {  
    discountAmount = 200;  

    setCouponMessage(  
      "✅ WELCOME200 Applied • Saved ₹200"  
    );  
  } else {  
    setDiscount(0);  

    setAppliedCoupon(null);  

    setCouponMessage(  
      "❌ Minimum order not reached"  
    );  

    return;  
  }  

  setDiscount(  
    Math.round(discountAmount)  
  );  

  setAppliedCoupon(  
    upperCode  
  );  
}, 100);

};

/* ================= REMOVE COUPON ================= */

const removeCoupon = () => {
setCouponCode("");

setDiscount(0);  

setAppliedCoupon(null);  

setCouponMessage("");

};



useEffect(() => {
  if (form.lat && form.lng) {
    calculateDelivery(
      form.lat,
      form.lng
    );
  }
}, [
  subtotal,
  form.lat,
  form.lng
]);




/* ================= TOTAL ================= */

const rawTotalAmount =
  subtotal +
  shippingCharge +
  smallOrderFee -
  discount;

// Nearest ₹1 round off
const totalAmount = Math.round(rawTotalAmount);

// Round off amount
const roundOff = Number(
  (totalAmount - rawTotalAmount).toFixed(2)
);

/* ================= PLACE ORDER ================= */

const placeOrder = async () => {
if (!form.name || !form.phone) {
return alert(
"Please enter customer details"
);
}

if (  
  !form.address ||  
  !form.lat ||  
  !form.lng  
) {  
  return alert(  
    "Please select delivery address"  
  );  
}  

try {  
  setPlacing(true);  

  const payload = {  
    user: userId,  

    orderItems:  
      validCartItems.map((i) => ({  
        product:  
          i.productId._id,  
        name:  
          i.productId.name,  
        qty: Number(i.quantity),  
        price: Number(  
          i.productId.price ||  
            i.price  
        )  
      })),  

    shippingAddress: {  
      ...form,  
      distance,  
      eta,  
      shippingCharge  
    },  

    paymentMethod,  

    coupon: appliedCoupon,  

    discount,  

    subtotal,  

    totalPrice: totalAmount  
  };  

  const orderRes =  
    await api.post(  
      "/api/orders",  
      payload  
    );  

  const orderId =  
    orderRes.data._id;  

  await api  
    .delete(  
      `/api/cart/clear/${userId}`  
    )  
    .catch(() => {});  

  setCartItems([]);  

  localStorage.removeItem(  
    "cart"  
  );  

  if (  
    paymentMethod ===  
    "ONLINE"  
  ) {  
    const payRes =  
      await api.post(  
        "/api/payment/initiate",  
        {  
          orderId,  
          userId  
        }  
      );  

    if (payRes?.data?.url) {  
      window.location.href =  
        payRes.data.url;  
    } else {  
      alert(  
        "Payment failed"  
      );  
    }  
  } else {  
    navigate(  
      `/order-confirmation/${orderId}`  
    );  
  }  
} catch (err) {  
  alert(  
    err.response?.data  
      ?.message ||  
      "Order failed"  
  );  
}  

setPlacing(false);

};

/* ================= LOADING ================= */

if (loading) {
return (
<div
className="d-flex justify-content-center align-items-center"
style={{
height: "100vh"
}}
>
<div className="spinner-border text-success" />
</div>
);
}

/* ================= UI ================= */

return (
<div
className="container py-3"
style={{
maxWidth: "700px",
paddingBottom: "120px"
}}
>
{/* ================= HEADER ================= */}

<div  
    className="p-4 rounded-4 text-white mb-3 shadow-lg position-relative overflow-hidden"  
    style={{  
      background:  
        "linear-gradient(135deg,#00b09b,#96c93d)"  
    }}  
  >  
    <div  
      style={{  
        position: "absolute",  
        top: "-20px",  
        right: "-20px",  
        width: "120px",  
        height: "120px",  
        borderRadius: "50%",  
        background:  
          "rgba(255,255,255,0.15)"  
      }}  
    />  

    <h2 className="fw-bold mb-1">  
      🛒 FreshCart Checkout  
    </h2>  

    <div className="small">  
      Fast Delivery • Fresh  
      Grocery • Secure Payments  
    </div>  
  </div>  

  {/* ================= DELIVERY STATUS ================= */}  

  <div className="row g-2 mb-3">  
    <div className="col-6">  
      <div  
        className="p-3 rounded-4 text-white shadow-sm"  
        style={{  
          background:  
            "linear-gradient(135deg,#fc466b,#3f5efb)"  
        }}  
      >  
        <div className="small">  
          Delivery Time  
        </div>  

        <div className="fw-bold fs-5">  
          🚴 {eta} mins  
        </div>  
      </div>  
    </div>  

    <div className="col-6">  
      <div  
        className="p-3 rounded-4 text-white shadow-sm"  
        style={{  
          background:  
            "linear-gradient(135deg,#f7971e,#ffd200)"  
        }}  
      >  
        <div className="small">  
          Distance  
        </div>  

        <div className="fw-bold fs-5">  
          📍{" "}  
          {distance.toFixed(2)} KM  
        </div>  
      </div>  
    </div>  
  </div>  

  {/* ================= CUSTOMER DETAILS ================= */}  

  <div className="card border-0 shadow rounded-4 mb-3">  
    <div className="card-body">  
      <h5 className="fw-bold mb-3">  
        👤 Customer Details  
      </h5>  

      <input  
        type="text"  
        className="form-control rounded-4 py-3 mb-3"  
        placeholder="Enter Full Name"  
        value={form.name}  
        onChange={(e) =>  
          setForm({  
            ...form,  
            name: e.target.value  
          })  
        }  
      />  

      <input  
        type="tel"  
        className="form-control rounded-4 py-3"  
        placeholder="Enter Phone Number"  
        value={form.phone}  
        onChange={(e) =>  
          setForm({  
            ...form,  
            phone: e.target.value  
          })  
        }  
      />  
    </div>  
  </div>  

  {/* ================= ADDRESS ================= */}  

  <div className="card border-0 shadow rounded-4 mb-3">  
    <div className="card-body">  
      <div  
        className="d-flex justify-content-between align-items-center"  
        style={{  
          cursor: "pointer"  
        }}  
        onClick={() =>  
          setShowAddressList(  
            !showAddressList  
          )  
        }  
      >  
        <div>  
          <h5 className="fw-bold mb-1">  
            📍 Delivery Address  
          </h5>  

          <div className="small text-muted">  
            {form.address ||  
              "Select Address"}  
          </div>  
        </div>  

        <div className="fw-bold">  
          {showAddressList  
            ? "▲"  
            : "▼"}  
        </div>  
      </div>  

      {showAddressList && (  
        <div className="mt-3">  
          {savedAddresses.map(  
            (addr, i) => (  
              <div  
                key={i}  
                className={`p-3 rounded-4 mb-2 border ${  
                  selectedIndex === i  
                    ? "bg-success text-white border-success"  
                    : "bg-light"  
                }`}  
                style={{  
                  cursor: "pointer"  
                }}  
                onClick={() =>  
                  selectAddress(  
                    addr,  
                    i  
                  )  
                }  
              >  
                <div className="fw-bold">  
                  {addr.name}  
                </div>  

                <div className="small">  
                  {addr.address}  
                </div>  
              </div>  
            )  
          )}  

          <button  
            className="btn btn-dark w-100 rounded-4 py-3 mt-2"  
            onClick={() =>  
              navigate(  
                "/address-manager"  
              )  
            }  
          >  
            + Add / Manage Address  
          </button>  
        </div>  
      )}  
    </div>  
  </div>  

  {/* ================= MAP ================= */}  

  <div className="card border-0 shadow rounded-4 mb-3">  
    <div className="card-body">  
      <h5 className="fw-bold mb-3">  
        🗺 Delivery Location  
      </h5>  

      {isLoaded && (  
        <GoogleMap  
          mapContainerStyle={  
            containerStyle  
          }  
          zoom={15}  
          center={{  
            lat:  
              form.lat ||  
              STORE_LOCATION.lat,  
            lng:  
              form.lng ||  
              STORE_LOCATION.lng  
          }}  
        >  
          <Marker  
            position={{  
              lat:  
                form.lat ||  
                STORE_LOCATION.lat,  
              lng:  
                form.lng ||  
                STORE_LOCATION.lng  
            }}  
          />  

          <Circle  
            center={STORE_LOCATION}  
            radius={10000}  
          />  
        </GoogleMap>  
      )}  
    </div>  
  </div>  

  {/* ================= ORDER SUMMARY ================= */}  

  <div className="card border-0 shadow rounded-4 mb-3">  
    <div className="card-body">  
      <div className="d-flex justify-content-between align-items-center mb-3">  
        <h5 className="fw-bold mb-0">  
          🧾 Order Summary  
        </h5>  

        <span className="badge bg-success rounded-pill">  
          {  
            validCartItems.length  
          }{" "}  
          Items  
        </span>  
      </div>  

      {validCartItems.map((i) => (  
        <div  
          key={i._id}  
          className="d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom"  
        >  
          <div>  
            <div className="fw-semibold">  
              {i.productId.name}  
            </div>  

            <div className="small text-muted">  
              Qty: {i.quantity}  
            </div>  
          </div>  

          <div className="fw-bold fs-6">  
            ₹  
            {i.quantity *  
              (i.productId  
                .price ||  
                i.price)}  
          </div>  
        </div>  
      ))}  
    </div>  
  </div>  

    

  {/* ================= OFFERS ================= */}  

  <div className="card border-0 shadow rounded-4 mb-3">  
    <div className="card-body">  
      <h5 className="fw-bold mb-3">  
        🏦 Bank Offers  
      </h5>  

      <div className="bg-white p-3 rounded-4 shadow-sm mb-3">  
        <div className="fw-bold">  
          💳 ICICI Debit Card  
        </div>  

        <div className="small text-muted">  
          Get upto 15% Cashback  
          on prepaid orders  
        </div>  
      </div>  

      <div className="bg-white p-3 rounded-4 shadow-sm">  
        <div className="fw-bold">  
          🛍 Axis Bank Cards  
        </div>  

        <div className="small text-muted">  
          Flat 20% OFF upto ₹200  
          on FreshCart  
        </div>  
      </div>  
    </div>  
  </div>  

  {/* ================= BILL DETAILS ================= */}  

  <div className="card border-0 shadow rounded-4 mb-3">  
    <div className="card-body">  
      <h5 className="fw-bold mb-3">  
        💰 Bill Details  
      </h5>  

      <div className="d-flex justify-content-between mb-2">  
        <span>Items Total</span>  
        <span>₹{subtotal}</span>  
      </div>  

      <div className="d-flex justify-content-between mb-2">  
        <span>  
          Delivery Charge  
        </span>  
        <span>  
          ₹{shippingCharge}  
        </span>  
      </div>  

      <div className="d-flex justify-content-between mb-2">  
        <span>  
          Small Order Fee  
        </span>  
        <span>  
          ₹{smallOrderFee}  
        </span>  
      </div>  

     {discount > 0 && (
  <div className="d-flex justify-content-between mb-2 text-success fw-bold">
    <span>
      Coupon Discount
    </span>

    <span>
      - ₹{discount}
    </span>
  </div>
)}

{/* ================= ROUND OFF ================= */}

{roundOff !== 0 && (
  <div className="d-flex justify-content-between mb-2">
    <span>Round Off</span>

    <span
      className={
        roundOff > 0
          ? "text-danger"
          : "text-success"
      }
    >
      {roundOff > 0 ? "+" : ""}
      ₹{Math.abs(roundOff).toFixed(2)}
    </span>
  </div>
)}

<hr />

      <div className="d-flex justify-content-between align-items-center">  
        <div>  
          <div className="fw-bold fs-5">  
            Total Amount  
          </div>  

          <div className="small text-success">  
            Inclusive of all  
            taxes  
          </div>  
        </div>  


        <div className="fw-bold fs-4 text-success">  
          ₹{totalAmount}  
        </div>  
      </div>  
    </div>  
  </div>  

  {/* ================= PAYMENT ================= */}  

  <div className="card border-0 shadow rounded-4 mb-4">  
    <div className="card-body">  
      <h5 className="fw-bold mb-3">  
        💳 Select Payment  
        Method  
      </h5>  

      <div  
        className={`p-3 rounded-4 border mb-3 ${  
          paymentMethod ===  
          "ONLINE"  
            ? "border-success bg-light"  
            : ""  
        }`}  
        style={{  
          cursor: "pointer"  
        }}  
        onClick={() =>  
          setPaymentMethod(  
            "ONLINE"  
          )  
        }  
      >  
        <div className="d-flex justify-content-between align-items-center">  
          <div>  
            <div className="fw-bold">  
              UPI / Credit /  
              Debit Card  
            </div>  

            <div className="small text-muted">  
              PhonePe, Google  
              Pay, Paytm, Visa,  
              MasterCard  
            </div>  
          </div>  

          <input  
            type="radio"  
            checked={  
              paymentMethod ===  
              "ONLINE"  
            }  
            readOnly  
          />  
        </div>  
      </div>  

      <div  
        className={`p-3 rounded-4 border ${  
          paymentMethod ===  
          "COD"  
            ? "border-success bg-light"  
            : ""  
        }`}  
        style={{  
          cursor: "pointer"  
        }}  
        onClick={() =>  
          setPaymentMethod(  
            "COD"  
          )  
        }  
      >  
        <div className="d-flex justify-content-between align-items-center">  
          <div>  
            <div className="fw-bold">  
              Cash on Delivery  
            </div>  

            <div className="small text-muted">  
              Pay after  
              receiving your  
              order  
            </div>  
          </div>  

          <input  
            type="radio"  
            checked={  
              paymentMethod ===  
              "COD"  
            }  
            readOnly  
          />  
        </div>  
      </div>  
    </div>  
  </div>  

  {/* ================= PLACE ORDER ================= */}  

  <div  
    className="position-fixed bottom-0 start-0 end-0 bg-white p-3 shadow-lg"  
    style={{  
      zIndex: 999  
    }}  
  >  
    <div className="d-flex justify-content-between align-items-center mb-2">  
      <div>  
        <div className="small text-muted">  
          To Pay  
        </div>  



        <div className="fw-bold fs-4 text-success">  
          ₹{totalAmount}  
        </div>  
      </div>  

      <button  
        className="btn btn-success px-5 py-3 rounded-4 fw-bold shadow"  
        style={{  
          background:  
            "linear-gradient(135deg,#00b09b,#96c93d)",  
          border: "none"  
        }}  
        onClick={placeOrder}  
        disabled={placing}  
      >  
        {placing  
          ? "Placing..."  
          : "Place Order"}  
      </button>  
    </div>  

    <div className="text-center small text-muted">  
      🔒 100% Safe & Secure  
      Payments  
    </div>  
  </div>  
</div>

);
};

export default ShopCheckOut;
